<template>
  <section id="about" class="fade-in section">
    <h2>{{ $t('about.title') }}</h2>
    <div class="about-grid">
      <div class="about-text">
        <p>{{ $t('about.text1') }}</p>
        <p><strong>{{ $t('about.vision_title') }}</strong> {{ $t('about.vision') }}</p>
        <p><strong>{{ $t('about.mission_title') }}</strong> {{ $t('about.mission') }}</p>
      </div>
      <div class="about-image">
        <i class="fas fa-user-md"></i>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: 'AboutSection' };
</script>

<style scoped>
.section { padding: 80px 10%; text-align: center; }
.about-grid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 2rem;
}
.about-text { flex: 1; text-align: start; line-height: 1.8; }
.about-image {
  flex: 0.4;
  text-align: center;
}
.about-image i {
  font-size: 8rem;
  color: #00c4fc;
}
.fade-in { animation: fadeIn 1.2s ease; }
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
